import { Pipe, PipeTransform } from '@angular/core';
import { crmExportValue } from '../../../helpers/crm-export-value';

@Pipe({
    name: 'crmExportValue',
    pure: true,
    standalone: false
})
export class CrmExportValuePipe implements PipeTransform {
  transform(crm: string): string {
    return crmExportValue(crm);
  }
} 
